import { render, staticRenderFns } from "./RegistrantNew.vue?vue&type=template&id=0ad1a0ad&"
import script from "./RegistrantNew.vue?vue&type=script&lang=js&"
export * from "./RegistrantNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports